import {imagen} from "./state";
import {filtros} from "./state";

/**
 * Establecer un valor para imagenes
 */
export function establecerImagenes(state, imagenes) {
  state.imagenes = imagenes;
}

/**
 * Establecer un valor para empresas
 */
export function establecerEmpresas(state, empresas) {
  state.empresas = empresas;
}

/**
 * Establecer un valor para imagenes_banner
 */
export function establecerImagenesBanner(state, imagenes_banner) {
  state.imagenes_banner = imagenes_banner;
}

/**
 * Establecer un valor para imagesBannerActive
 */
export function setImageBannerActive(state, image) {
  state.imageBannerActive = image;
}

/**
 * Establecer un valor para imagen.archivo
 */
export function establecerArchivoImagen(state, event) {
  const archivo = event.target.files;

  state.imagen.archivo = null;

  if (archivo[0]) {
    state.imagen.archivo = archivo[0];
  }
}

/**
 * Establecer un valor para imagen
 */
export function reestablecerImagen(state) {
  state.imagen = imagen();
}

/**
 * Establecer un valor para modal.mostrar
 */
export function establecerModal(state, mostrar) {

  if (mostrar) {
    state.imagen.archivo = null;
  }
  state.modal.mostrar = mostrar;
}

/**
 * Establecer un valor para modal_banner.mostrar
 */
export function establecerModalBanner(state, mostrar) {

  state.modal_banner.mostrar = mostrar;
}

/**
 * Establecer un valor para modal_imagen.mostrar
 */
export function establecerModalImagen(state, mostrar) {

  if (!mostrar) {
    state.imagen.archivo = null;
  }

  state.modal_imagen.mostrar = mostrar;
}


/**
 * Establecer un valor para filtros
 */
export function establecerFiltros(state, filtros) {
  state.filtros = filtros;
}

/**
 * Establecer un valor para imagen.id_empresa
 */
export function estblacerIdEmpresaImagen(state, id_empresa) {
  state.imagen.id_empresa = id_empresa;
}


/**
 * Establecer un valor para filtros.id_empresa
 */
export function estblacerIdEmpresaFiltros(state, id_empresa) {
  state.filtros.id_empresa = id_empresa;
}

/**
 * Restablecer filtros
 */
export function restablecerFiltros(state) {
  state.filtros = filtros();
  state.imagenes = {
    data: []
  };
}

/**
 * Establecer un valor para cargando_datos_select
 */
export function establecerCargandoDatosSelect(state, cargando_datos_select) {
  state.cargando_datos_select = cargando_datos_select;
}

/**
 * Establecer un valor para imagen
 */
export function establecerImagen(state, imagen) {
  state.imagen = imagen;
}

/**
 * Función para paginar
 *
 * @param {*} state
 */
 export function setPorPagina(state, perPage) {
    if(isNaN(perPage)) return;
    state.filtros.page = 1;
    state.filtros.cantidad = perPage
}

/**
 * Función para cambiar de pagina
 *
 * @param {*} state
 */
export function setPagina(state, page) {
    state.filtros.page = page
}

/**
 * Establecer empresas para carga de imagenes
 */
 export function establecerEmpresasCarga(state, empresas) {
    state.cargarEmpresas = empresas;
}

/**
 * Restablecer empresas carga
 */
 export function restablecerEmpresasCarga(state) {
    state.cargarEmpresas = [];
    state.inputEmpresas = {
        ids: []
    }
  }
